import React from "react";
import { Card, Col, Row, Statistic } from "antd";
import { CheckCircleOutlined, ClockCircleOutlined, DollarOutlined } from "@ant-design/icons";

export default function CardsValores(props) {
  const { valorPago, valorPendente, valorTotal, formatarMoedaBr } = props;

  // Brand colors
  const redColor = "#E53935"; // Vibrant red
  const blackColor = "#333333";
  const grayColor = "#F5F5F5";

  return (
    <Row gutter={16} style={{ marginBottom: 20 }}>
      {/* Valor Pago */}
      <Col xs={24} sm={8}>
        <Card
          bordered={false}
          style={{
            height: "100%",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            background: "linear-gradient(to right bottom, #ffffff, #f6ffed)", // Light Green Tint
            borderLeft: "5px solid #52c41a"
          }}
        >
          <Statistic
            title={<span style={{ color: "#555", fontWeight: 600 }}>Valor pago</span>}
            value={valorPago}
            formatter={(val) => formatarMoedaBr(val)}
            valueStyle={{ color: "#3f8600", fontWeight: "bold" }}
            prefix={<CheckCircleOutlined style={{ marginRight: 8 }} />}
          />
        </Card>
      </Col>

      {/* Valor Pendente */}
      <Col xs={24} sm={8}>
        <Card
          bordered={false}
          style={{
            height: "100%",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            background: "linear-gradient(to right bottom, #ffffff, #fff1f0)", // Light Red Tint
            borderLeft: "5px solid #cf1322"
          }}
        >
          <Statistic
            title={<span style={{ color: "#555", fontWeight: 600 }}>Valor pendente</span>}
            value={valorPendente}
            formatter={(val) => formatarMoedaBr(val)}
            valueStyle={{ color: "#cf1322", fontWeight: "bold" }}
            prefix={<ClockCircleOutlined style={{ marginRight: 8 }} />}
          />
        </Card>
      </Col>

      {/* Valor Total */}
      <Col xs={24} sm={8}>
        <Card
          bordered={false}
          style={{
            height: "100%",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            background: "linear-gradient(to right bottom, #ffffff, #f0f5ff)", // Light Blue Tint
            borderLeft: "5px solid #2f54eb"
          }}
        >
          <Statistic
            title={<span style={{ color: "#555", fontWeight: 600 }}>Valor total</span>}
            value={valorTotal}
            formatter={(val) => formatarMoedaBr(val)}
            valueStyle={{ color: "#1d39c4", fontWeight: "bold" }}
            prefix={<DollarOutlined style={{ marginRight: 8 }} />}
          />
        </Card>
      </Col>
    </Row>
  );
}